import { ChangeDetectorRef, computed, ElementRef, forwardRef, inject, input, TemplateRef } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccessState, DynamicComponentDirective, DynamicComponentIOCheck, ModelFieldInstructionService } from '@core/frontend-shared';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import { BehaviorSubject, combineLatest, map, take } from 'rxjs';
import { ModelFormServiceFactory } from '../form-service';
import { ModelBasedControlValueAccessor } from '../model-based-control-value-accessor';
import { isConstructor } from '@core/shared/utils';
import { Store } from '@ngxs/store';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { InstructionOutletComponent } from '../instruction-outlet/instruction-outlet.component';
import { UiContentCenteredComponent } from '@common/ui/frontend-shared/content-centered';
import { UiSpinnerComponent } from '@common/ui/frontend-shared/spinner';
import * as i0 from "@angular/core";
import * as i1 from "../form-service";
import * as i2 from "@core/frontend-shared";
import * as i3 from "@angular/forms";
const _c0 = (a0, a1, a2, a3, a4) => ({
  formGroup: a0,
  formService: a1,
  parentFormService: a2,
  model: a3,
  data: a4
});
function SimpleFieldsetComponent_Conditional_0_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SimpleFieldsetComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, SimpleFieldsetComponent_Conditional_0_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r1.formService.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.innerForm)("ngTemplateOutletContext", i0.ɵɵpureFunction5(3, _c0, ctx_r1.formService.formGroup, ctx_r1.formService, ctx_r1.parentFormService, ctx_r1.formService.formGroup.getRawValue(), ctx_r1.innerFormData));
  }
}
function SimpleFieldsetComponent_Conditional_0_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SimpleFieldsetComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SimpleFieldsetComponent_Conditional_0_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 5);
  }
  if (rf & 2) {
    i0.ɵɵproperty("dynamicComponent", ctx);
  }
}
function SimpleFieldsetComponent_Conditional_0_Conditional_3_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "instruction-outlet", 6);
  }
  if (rf & 2) {
    const instruction_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("instruction", instruction_r3)("formService", ctx_r1.formService);
  }
}
function SimpleFieldsetComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵrepeaterCreate(1, SimpleFieldsetComponent_Conditional_0_Conditional_3_For_2_Template, 1, 2, "instruction-outlet", 6, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r1.formService.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx);
  }
}
function SimpleFieldsetComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("keyup.enter", function SimpleFieldsetComponent_Conditional_0_Template_div_keyup_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEnter($event));
    })("keyup.control.enter", function SimpleFieldsetComponent_Conditional_0_Template_div_keyup_control_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEnter($event));
    });
    i0.ɵɵconditionalCreate(1, SimpleFieldsetComponent_Conditional_0_Conditional_1_Template, 2, 9, "div", 2);
    i0.ɵɵconditionalCreate(2, SimpleFieldsetComponent_Conditional_0_Conditional_2_Template, 1, 1, "ng-container");
    i0.ɵɵconditionalCreate(3, SimpleFieldsetComponent_Conditional_0_Conditional_3_Template, 3, 1, "div", 3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.innerForm ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_2_0 = ctx_r1.innerFormComponentConfig()) ? 2 : -1, tmp_2_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_3_0 = i0.ɵɵpipeBind1(4, 3, ctx_r1.allInstructions$)) ? 3 : -1, tmp_3_0);
  }
}
function SimpleFieldsetComponent_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "br");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" fieldset initialized: ", ctx_r1.initialized);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" formService initialized - local: ", ctx_r1.formServiceInitialized, " / origin: ", ctx_r1.formService ? ctx_r1.formService.initialized : "unknown", " ");
  }
}
function SimpleFieldsetComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-content-centered")(1, "div");
    i0.ɵɵelement(2, "ui-spinner");
    i0.ɵɵtext(3, " Editor wird initialisiert... ");
    i0.ɵɵconditionalCreate(4, SimpleFieldsetComponent_Conditional_2_Conditional_4_Template, 4, 3, "small", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r1.isDev ? 4 : -1);
  }
}
function SimpleFieldsetComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function SimpleFieldsetComponent_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showDebug());
    });
    i0.ɵɵtext(1, "Debug Form");
    i0.ɵɵelementEnd();
  }
}
export const SIMPLE_FIELDSET_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SimpleFieldsetComponent),
  multi: true
};
export const SIMPLE_FIELDSET_VALIDATOR = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => SimpleFieldsetComponent),
  multi: true
};
/**
 * SimpleFieldset continues to support both the new ModelFormService and the fast "classic" way to create the form group by itself.
 *
 * It provides two ways to build a form: Either provide [instructions] list, or pass a custom form to [innerForm].
 */
export let SimpleFieldsetComponent = /*#__PURE__*/(() => {
  class SimpleFieldsetComponent extends ModelBasedControlValueAccessor {
    set instructions(instructions) {
      this.directInstructions$.next(instructions);
    }
    get instructions() {
      console.warn('synchronous access to form instructions is deprecated. Use allInstructions$ isntead!');
      return this.directInstructions$.getValue();
    }
    constructor(cd, formServiceFactory, pluginInstructionsService) {
      super(cd, formServiceFactory);
      this.cd = cd;
      this.formServiceFactory = formServiceFactory;
      this.pluginInstructionsService = pluginInstructionsService;
      // instructions input is still used, but only FilterFieldset supports use of instructions WITHOUT Model or custom FormGroup now!
      this.directInstructions$ = new BehaviorSubject([]);
      this.pluginInstructions$ = new BehaviorSubject([]);
      this.allInstructions$ = combineLatest([this.directInstructions$, this.pluginInstructions$]).pipe(map(([staticInstructions, pluginInstructions]) => {
        return this.pluginInstructionsService.addPluginInstructionsToStaticInstructions(staticInstructions, pluginInstructions);
      }), takeWhileAlive());
      this.innerFormComponent = input(null, ...(ngDevMode ? [{
        debugName: "innerFormComponent"
      }] : /* istanbul ignore next */[]));
      this.innerFormComponentConfig = computed(() => {
        const cmp = this.innerFormComponent();
        if (!cmp) return null;
        const fs = this.initializedFormService();
        if (!fs) return null;
        return this.setupInnerFormComponent(fs, cmp);
      }, ...(ngDevMode ? [{
        debugName: "innerFormComponentConfig"
      }] : /* istanbul ignore next */[]));
      this.innerFormData = {};
      this.submitShortcut = 'ctrl+enter';
      // if configurated, the fieldset can check for dynamic addon fields to show.
      this.contextGroups = false;
      this.isSU$ = inject(Store).select(AccessState.isSuperUser);
      this.showDebugButton$ = this.isSU$.pipe(map(isSU => {
        return isSU || !IS_PRODUCTION;
      }));
      this.initializedFormService$.pipe(takeWhileAlive()).subscribe(formService => {
        if (formService && pluginInstructionsService) {
          if (!formService.initialized) throw new Error('must never happen!');
          this.setupPluginInstructions(formService);
        }
      });
    }
    setupPluginInstructions(formService) {
      const ModelConstructor = formService.modelFactory.getOriginalModel();
      this.getPluginInstructions(ModelConstructor).pipe(take(1) // if not limited take, we'd need unsubscribe/resubscribe management as formService$ could emit multiple times
      ).subscribe(pluginInstructions => {
        // if(instructions.length && this.innerForm) {
        // 	console.warn('Fieldset uses custom innerForm but received pluginInstructions as well. This is unsupported currently. pluginInstructions will not show.')
        // }
        this.pluginInstructions$.next(pluginInstructions);
      });
    }
    getPluginInstructions(ModelConstructor) {
      return this.pluginInstructionsService.getPluginInstructions(ModelConstructor, this.contextGroups || undefined, this.formService.getEditorDefinition(), null // simple fieldset does not know about ItemEditModes
      );
    }
    submit() {
      if (this.formService) this.formService.save();
    }
    setupInnerFormComponent(formService, cmp) {
      if (!isConstructor(cmp)) {
        return cmp;
      } else {
        return {
          component: cmp,
          inputs: {
            formGroup: formService.formGroup,
            formService: formService,
            parentFormService: this.parentFormService,
            item: formService.getValueIncludingReadonly(),
            data: this.innerFormData
          },
          // template component has only the inputs that it needs, disable erroring in case of missing IOs
          IOCheck: DynamicComponentIOCheck.FilterUnknown
        };
      }
    }
    showDebug() {
      console.log(this.formService);
    }
    onEnter(event) {
      const isCtrl = event.ctrlKey;
      if (this.submitShortcut === 'ctrl+enter') {
        if (isCtrl) this.submit();
      } else {
        this.submit();
      }
    }
    static {
      this.ɵfac = function SimpleFieldsetComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SimpleFieldsetComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.ModelFormServiceFactory), i0.ɵɵdirectiveInject(i2.ModelFieldInstructionService, 8));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: SimpleFieldsetComponent,
        selectors: [["simple-fieldset"]],
        inputs: {
          instructions: "instructions",
          title: "title",
          innerForm: "innerForm",
          innerFormComponent: [1, "innerFormComponent"],
          innerFormData: "innerFormData",
          submitShortcut: "submitShortcut",
          contextGroups: "contextGroups"
        },
        features: [i0.ɵɵProvidersFeature([SIMPLE_FIELDSET_VALUE_ACCESSOR, SIMPLE_FIELDSET_VALIDATOR]), i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 6,
        consts: [[1, "debug-btn"], [3, "keyup.enter", "keyup.control.enter"], [1, "custom-form", 3, "formGroup"], [1, "form-fields", 3, "formGroup"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "dynamicComponent"], [3, "instruction", "formService"], [2, "display", "block", "opacity", ".5"], [1, "debug-btn", 3, "click"]],
        template: function SimpleFieldsetComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, SimpleFieldsetComponent_Conditional_0_Template, 5, 5, "div");
            i0.ɵɵpipe(1, "async");
            i0.ɵɵconditionalBranchCreate(2, SimpleFieldsetComponent_Conditional_2_Template, 5, 1, "ui-content-centered");
            i0.ɵɵconditionalCreate(3, SimpleFieldsetComponent_Conditional_3_Template, 2, 0, "button", 0);
            i0.ɵɵpipe(4, "async");
          }
          if (rf & 2) {
            i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 2, ctx.allInitialized$) ? 0 : 2);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(i0.ɵɵpipeBind1(4, 4, ctx.showDebugButton$) ? 3 : -1);
          }
        },
        dependencies: [FormsModule, i3.NgControlStatusGroup, ReactiveFormsModule, i3.FormGroupDirective, NgTemplateOutlet, DynamicComponentDirective, InstructionOutletComponent, UiContentCenteredComponent, UiSpinnerComponent, AsyncPipe],
        styles: ["[_nghost-%COMP%]{display:block;position:relative}.debug-btn[_ngcontent-%COMP%]{position:absolute;top:0;right:0}.form-fields[_ngcontent-%COMP%] > *[_ngcontent-%COMP%] + *[_ngcontent-%COMP%]{margin-top:10px;display:block}.custom-form[_ngcontent-%COMP%] + .form-fields[_ngcontent-%COMP%]{margin-top:10px}\n\n/*# sourceMappingURL=simple-fieldset.component.ts-angular-inline--10.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return SimpleFieldsetComponent;
})();